module.exports = __webpack_public_path__ + "5dd3dc166f685f50af7074ca75a64db6.png";